"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalRule = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var HorizontalRuleElement = _styledComponents["default"].hr.withConfig({
  displayName: "HorizontalRule__HorizontalRuleElement",
  componentId: "sc-198gjx4-0"
})(["", ";border:0;border-block-start:1px solid ", ";margin-block:", ";"], (0, _index.rootStyle)(), (0, _index.cssColorValue)(_index.semanticColors.decorativeSubdued), (0, _index.cssSpacing)('looser', '24px'));

/**
 * HorizontalRule is a thin line that is inserted into flow content to denote a break in the content, without introducing a new section as a heading would.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-horizontalrule--docs) |
 * [Encore site](https://encore.spotify.net/web/components/horizontal-rule) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/HorizontalRule) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=3755-6810&t=SlcSOGwMfUq5fUJD-1)
 */
var HorizontalRule = exports.HorizontalRule = function HorizontalRule(_ref) {
  var props = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(_ref), _ref));
  return /*#__PURE__*/_react["default"].createElement(HorizontalRuleElement, Object.assign({}, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.HorizontalRule
  }));
};